import styled from 'styled-components';

export const RhRawButton = styled.button`
  all: unset;
  appearance: none;
  outline: none;
  cursor: pointer;
  display: flex;

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;
